module.exports = __webpack_public_path__ + "static/media/BANNER_PLAN_SILVERS_386x245_desktop.ac504ea0.jpg";